import { render, staticRenderFns } from "./OrgExternalDonorsPage.vue?vue&type=template&id=7c8684f8&scoped=true&"
import script from "./OrgExternalDonorsPage.vue?vue&type=script&lang=js&"
export * from "./OrgExternalDonorsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8684f8",
  null
  
)

export default component.exports